import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const REFERRAL_SOURCE_USER = 'referral_src_usr';

export default function useReferralSource() {
  const [hasMounted, setHasMounted] = useState(false);
  const location = useLocation();
  const urlParams = useParams();

  // This function is used to clear session storage
  // after an appointment has been booked and confirmed
  const resetReferralUser = () => {
    sessionStorage.removeItem(REFERRAL_SOURCE_USER)
  }

  useEffect(() => {
    if (!hasMounted) {
      setHasMounted(true);
      const referralUrlMatch = new RegExp('\/referral\/*').test(location.pathname);
      if (location.pathname === '/login') {
        resetReferralUser();
      }
      else if (referralUrlMatch && !!urlParams.shortId) {
        const isReferralSource = referralUrlMatch && !!urlParams.shortId;
        sessionStorage.setItem(REFERRAL_SOURCE_USER, isReferralSource);
      }
    }
  }, [
    hasMounted,
    urlParams?.shortId,
    location.pathname
  ]);

  return {
    isReferralSource: sessionStorage.getItem(REFERRAL_SOURCE_USER) === "true",
    resetReferralUser
  };
}
